import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import { Link, withRouter } from "react-router";
import { Helmet } from "react-helmet";
import { Div } from "components/Base";
import { getters } from "Portal/CallForPapersForm/model";
import Logo from "Portal/CallForPapersForm/View/Logo";
import Steps from "Portal/CallForPapersForm/View/Steps";
import WelcomePage from "Portal/CallForPapersForm/View/WelcomePage";
import CloseAt from "./CloseAt";
import ViewOnly from "./ViewOnly";
import GroupPage from "Portal/CallForPapersForm/View/GroupPage";
import ContactPage from "Portal/CallForPapersForm/View/ContactPage";
import LoginPage from "Portal/CallForPapersForm/View/LoginPage";
import Loading from "ui-kit/Loading";
import PlatformLoading from "components/Platform/PlatformLoading";
import MediaQuery from "react-responsive";
import WelcomeLoginSection from "./WelcomeLoginSection";
import PoweredbyLennd from "components/PortalV2/PoweredbyLennd";
import {
  getPageTitle,
  getIsEditing,
  getCssCode,
  getJsCode,
  getHeaderCustomHtml,
  getFooterCustomHtml,
  getBackgroundImageAltText,
  getBackgroundImageUrlBig,
  getBackgroundImageUrlSmall
} from "../selectors";
import css from "./styles.scss";
import { Style } from "react-style-tag";
import LoggedInAs from "./LoggedInAs";
import Snackbar from "ui-kit/Snackbar/View";
import Editing from "./Editing";
import SubmissionLimitReached from "./SubmissionLimitReached";
import HtmlInjector from "./HtmlInjector";

const Small = props => <MediaQuery {...props} maxWidth={420} />;
const Big = props => <MediaQuery {...props} minWidth={421} />;
const Mobile = props => <MediaQuery {...props} maxWidth={820} />;
const Default = props => <MediaQuery {...props} minWidth={821} />;

const decorate = connect(state => ({
  isLoggedIn: getters.isLoggedIn(state),
  activeIndex: getters.activeIndex(state),
  formData: getters.formData(state),
  loading: getters.loading(state),
  pageTitle: getPageTitle(state),
  editing: getIsEditing(state),
  isClosed: getters.isClosed(state),
  isViewOnly: getters.isViewOnly(state),
  showConfirmation: getters.showConfirmation(state),
  backgroundImageUrlBig: getBackgroundImageUrlBig(state),
  backgroundImageUrlSmall: getBackgroundImageUrlSmall(state),
  backgroundImageAltText: getBackgroundImageAltText(state),
  cssCode: getCssCode(state),
  jsCode: getJsCode(state),
  headerCustomHtml: getHeaderCustomHtml(state),
  footerCustomHtml: getFooterCustomHtml(state),
  userCanSubmitNewSubmissions: getters.userCanSubmitNewSubmissions(state)
}));

const ConfirmationScreen = ({ message }) => {
  return (
    <div
      style={{
        background: "#FFF",
        height: "52vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28 4.375C14.9522 4.375 4.375 14.9522 4.375 28C4.375 41.0477 14.9522 51.625 28 51.625C41.0477 51.625 51.625 41.0477 51.625 28C51.625 14.9522 41.0477 4.375 28 4.375Z"
          fill="#018755"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.1947 36.0252L22.7031 34.5337L37.1566 20.0274C37.6508 19.5332 38.4522 19.5332 38.9465 20.0274L39.5431 20.624C40.0373 21.1183 40.0373 21.9197 39.5431 22.4139L25.9845 36.0252C25.4903 36.5195 24.6889 36.5195 24.1947 36.0252Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.4742 34.5337L25.9826 36.0253C25.4884 36.5195 24.687 36.5195 24.1928 36.0253L18.2535 30.086C17.7592 29.5918 17.7592 28.7904 18.2535 28.2962L18.8501 27.6996C19.3444 27.2053 20.1457 27.2053 20.64 27.6996L27.4742 34.5337Z"
          fill="white"
        />
      </svg>

      <div
        style={{
          color: "#494949",
          textAlign: "center",
          fontSize: 16,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "130%"
        }}
        dangerouslySetInnerHTML={{
          __html: message
        }}
      ></div>
    </div>
  );
};

const Pages = ({
  handlers,
  mobile,
  activeIndex,
  loading,
  route,
  editing,
  isClosed,
  isViewOnly,
  userCanSubmitNewSubmissions
}) => {
  return !loading ? (
    <>
      {route.name !== "callForPapersLogin" ? (
        <>
          <Steps mobile={mobile} />

          <ViewOnly />
          {!isViewOnly && <CloseAt />}
          {editing && !isClosed && !isViewOnly ? <Editing /> : null}
          {!editing && !userCanSubmitNewSubmissions ? (
            <SubmissionLimitReached />
          ) : null}
          {activeIndex === 0 && <WelcomePage mobile={mobile} />}
          {activeIndex === 1 && <LoginPage handlers={handlers} />}
          {activeIndex === 2 && <GroupPage handlers={handlers} />}
          {activeIndex === 3 && <ContactPage handlers={handlers} />}

          <LoggedInAs />
        </>
      ) : (
        <LoginPage />
      )}
    </>
  ) : (
    <Loading height={400} />
  );
};

const LazyImage = ({ src, alt, height }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      width="100%"
      height={height}
      loading="eager"
      fetchPriority="high"
      style={{
        objectFit: "cover",
        display: "block",
        opacity: loaded ? 1 : 0,
        transition: "opacity 0.3s ease-in-out"
      }}
      onLoad={() => setLoaded(true)}
    />
  );
};

const preloadImages = urls => {
  const existingLinks = new Set(
    Array.from(
      document.head.querySelectorAll("link[rel='preload']")
    ).map(link => link.getAttribute("href"))
  );

  const addedLinks = [];

  urls.forEach(url => {
    if (url && !existingLinks.has(url)) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      link.fetchPriority = "high";
      document.head.appendChild(link);
      addedLinks.push(link);
    }
  });

  return () => {
    addedLinks.forEach(link => document.head.removeChild(link));
  };
};

const Layout = ({
  isLoggedIn,
  handlers,
  activeIndex,
  formData,
  route,
  loading,
  pageTitle,
  editing,
  isClosed,
  isViewOnly,
  showConfirmation,
  userCanSubmitNewSubmissions,
  backgroundImageUrlBig,
  backgroundImageUrlSmall,
  backgroundImageAltText,
  cssCode,
  jsCode,
  headerCustomHtml,
  footerCustomHtml
}) => {
  useEffect(() => {
    return preloadImages([backgroundImageUrlBig, backgroundImageUrlSmall]);
  }, [backgroundImageUrlBig, backgroundImageUrlSmall]);

  if (route.name === "callForPapersCallback") {
    return <PlatformLoading message="Logging in..." />;
  }

  const eventName = R.propOr("", "event_name", formData);

  return (
    <>
      {/** Injects JS/CSS code into <head/> tag */}
      <HtmlInjector headHtml={jsCode} footerHtml={null} />

      {/** Sets meta tags and title */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{pageTitle}</title>
      </Helmet>

      {/** Injects CSS code into a <style/> tag */}
      {cssCode && <Style>{cssCode}</Style>}

      <Link
        to="#main"
        onlyActiveOnIndex={true}
        tabIndex={0}
        aria-label="Skip to main content"
      />

      {/** Injects HTML code into a <div/> tag */}
      {headerCustomHtml ? (
        <div
          className="inject-header-html"
          id="inject-header-html"
          dangerouslySetInnerHTML={{
            __html: headerCustomHtml
          }}
        ></div>
      ) : null}

      <Div id="main" className={css.mainContainer}>
        <Small>
          <LazyImage
            src={backgroundImageUrlSmall}
            alt={backgroundImageAltText}
            height={330}
          />
        </Small>

        <Big>
          <LazyImage
            src={backgroundImageUrlBig}
            alt={backgroundImageAltText}
            height={440}
          />
        </Big>

        <Mobile>
          <Div
            display="column.flex-start.center"
            width={1}
            style={{ position: "absolute", top: 135, left: 0 }}
          >
            <Div
              bg="white"
              width={1}
              mb={4}
              p={4}
              style={{
                borderRadius: "6px",
                boxShadow:
                  "0 9px 17px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.17)"
              }}
            >
              <Logo eventName={eventName} />
              {showConfirmation ? (
                <ConfirmationScreen
                  message={R.prop("success_confirmation_message", formData)}
                />
              ) : (
                <Pages
                  handlers={handlers}
                  mobile
                  activeIndex={activeIndex}
                  loading={loading}
                  route={route}
                  editing={editing}
                  isClosed={isClosed}
                  isViewOnly={isViewOnly}
                  userCanSubmitNewSubmissions={userCanSubmitNewSubmissions}
                  eventName={eventName}
                />
              )}
            </Div>

            {isLoggedIn ? null : (
              <Div
                width={1}
                mb={6}
                p={4}
                bg="neutral0"
                style={{
                  borderRadius: "6px"
                }}
              >
                <WelcomeLoginSection handlers={handlers} />
              </Div>
            )}
            <PoweredbyLennd
              style={{
                margin: "20px 0"
              }}
            />

            {footerCustomHtml ? (
              <div
                className="inject-footer-html"
                id="inject-footer-html"
                dangerouslySetInnerHTML={{
                  __html: footerCustomHtml
                }}
              ></div>
            ) : null}
          </Div>
        </Mobile>
        <Default>
          <Div
            style={{ position: "absolute", top: 135, left: 0 }}
            display="column.flex-start.center"
            width={1}
          >
            <Div
              bg="white"
              width={820}
              mb={4}
              pt={10}
              pb={8}
              px={14}
              style={{
                borderRadius: "6px",
                boxShadow:
                  "0 9px 17px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.17)"
              }}
            >
              <Logo eventName={eventName} />
              {showConfirmation ? (
                <ConfirmationScreen
                  message={R.prop("success_confirmation_message", formData)}
                />
              ) : (
                <Pages
                  handlers={handlers}
                  activeIndex={activeIndex}
                  loading={loading}
                  route={route}
                  editing={editing}
                  isClosed={isClosed}
                  isViewOnly={isViewOnly}
                  userCanSubmitNewSubmissions={userCanSubmitNewSubmissions}
                  eventName={eventName}
                />
              )}
            </Div>

            <PoweredbyLennd
              style={{
                margin: "20px 0"
              }}
            />

            {footerCustomHtml ? (
              <div
                className="inject-footer-html"
                id="inject-footer-html"
                dangerouslySetInnerHTML={{
                  __html: footerCustomHtml
                }}
              ></div>
            ) : null}
          </Div>
        </Default>
      </Div>
      <Snackbar zIndex={2147483647} />
    </>
  );
};

export default R.compose(withRouter, decorate)(Layout);
